import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IUpdateTitleConfigurationPayload } from "../utils/types";
import { apiFetch } from "@core/index";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";

export const useUpdateTitleConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: {
      payload: IUpdateTitleConfigurationPayload;
    }) => {
      const { id, payloadData } = config.payload;
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/${id}`, {
        method: "PATCH",
        body: payloadData,
      });
      // Treat non-2xx app-level responses as errors so React Query transitions to the error state
      if (response.statusCode >= 400) {
        throw new Error(response.message || "Failed to update configuration");
      }
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar("Configuration updated successfully.", {
        variant: "success",
        autoHideDuration: 2000,
      });
      queryClient.invalidateQueries({ queryKey: ["titleConfigurationList"] });
    },
    onError: (error: Error) => {
      console.error("Failed to update title configuration:", error.message);
    },
  });
};
